import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

/**
 * Shared editorial layout for the /terms, /privacy, /refund pages.
 * Provides the eyebrow, H1, effective-date line, and prose styles.
 * All three pages share the same visual grammar.
 */
export default function LegalPage({ eyebrow, title, effectiveDate, testId, children }) {
  return (
    <div className="min-h-screen bg-[#FAFAFA]">
      <Navbar />
      <main
        data-testid={testId}
        className="mx-auto max-w-3xl px-6 pb-16 pt-14 lg:px-10 lg:pt-20"
      >
        <p className="mb-3 text-xs uppercase tracking-[0.25em] text-neutral-500">
          — {eyebrow}
        </p>
        <h1 className="font-serif text-4xl font-bold tracking-tight sm:text-5xl">
          {title}
        </h1>
        <p className="mt-4 text-xs text-neutral-500">
          Effective date: {effectiveDate}
        </p>

        <div className="legal-prose mt-10 space-y-8 text-[15px] leading-relaxed text-neutral-800">
          {children}
        </div>

        <p className="mt-16 border-t border-neutral-200 pt-6 text-xs text-neutral-500">
          Questions? Email{" "}
          <a
            href="mailto:support@postshifted.com"
            className="text-coral hover:text-coral-hover"
          >
            support@postshifted.com
          </a>
          .
        </p>
      </main>
      <Footer />
    </div>
  );
}

/** Convenience section — a numbered H2 + its body. */
export function LegalSection({ n, title, children }) {
  return (
    <section>
      <h2 className="font-serif text-2xl font-semibold tracking-tight text-neutral-900">
        <span className="mr-3 text-neutral-400">{String(n).padStart(2, "0")}.</span>
        {title}
      </h2>
      <div className="mt-3 space-y-3 text-neutral-700">{children}</div>
    </section>
  );
}
